import * as angular from 'angular';

export const SQLServerInstanceValidator = function () {
  return {
    scope: {},
    require: 'ngModel',
    link: function (scope, elm, attrs, ngModel) {
      ngModel.$validators.verify_sqlserver_instance_field_special_characters = function (modelValue, viewValue) {
        if (ngModel.$isEmpty(modelValue)) {
          //consider empty models to be valid
          return true;
        } else if (/[\\,:;'&\-@]/.test(viewValue)) {
          //instance name cannot contain the backslash (\), comma (,), colon (:), semi-colon (;), single quote ('), ampersand (&), hyphen (-), and at sign (@)
          return false;
        } else {
          return true;
        }
      };
    },
  };
};

angular.module('mode.components').directive('sqlServerInstanceValidator', SQLServerInstanceValidator);
